/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { compile, FormatCallback } from 'html-to-text';

const pearltagFormatter: FormatCallback = (elem, walk, builder) => {
  const tag = elem.attribs['data-tag'];
  const title = tag ? `${tag.charAt(0).toUpperCase() + tag.slice(1)}:\n  ` : '';

  builder.openBlock({ leadingLineBreaks: 1 });
  builder.addInline(title);
  walk(elem.children, builder); // Process the inner content
  builder.closeBlock({ trailingLineBreaks: 1 });
};

export const compiledHtmlConvert = compile({
  wordwrap: false,
  formatters: { pearltagFormatter },
  selectors: [
    { selector: 'a', format: 'inline' },
    { selector: 'fhir', format: 'inline' },
    { selector: 'actioncontent', format: 'inline' },
    { selector: 'action', format: 'inline' },
    { selector: 'pearltag', format: 'pearltagFormatter' },
  ],
});

export const compiledHtmlConvertPlain = compile({
  wordwrap: false,
  selectors: [
    { selector: 'a', format: 'inline' },
    { selector: 'fhir', format: 'inline' },
    { selector: 'actioncontent', format: 'skip' },
    { selector: 'action', format: 'skip' },
    { selector: 'pearltag', format: 'skip' },
  ],
});
